import { render, staticRenderFns } from "./DatatableWrapper.vue?vue&type=template&id=5b80fdc3&scoped=true"
import script from "./DatatableWrapper.vue?vue&type=script&lang=js"
export * from "./DatatableWrapper.vue?vue&type=script&lang=js"
import style0 from "./DatatableWrapper.vue?vue&type=style&index=0&id=5b80fdc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b80fdc3",
  null
  
)

export default component.exports